module.exports = __webpack_public_path__ + "img/nanya-house.5c1f36d5.png";